// test859
(859 && 0);
